module.exports = __webpack_public_path__ + "img/maxrecursoicms.03142d3d.png";